import { LogoFull, LogoMark } from "./Logo";

export const Footer = ({ email }) => (
  <footer className="border-t border-amber-500/10 bg-[#0B0D10]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <LogoFull />
        <p className="text-sm text-[#A1A8B3] mt-5 max-w-xs leading-relaxed">
          Bespoke custom cardboard tubes and cylinder packaging, printed and finished to your brand.
        </p>
      </div>
      <div>
        <p className="font-mono-spec text-[10px] uppercase tracking-[0.3em] text-[#666F7D] mb-4">Explore</p>
        <div className="flex flex-col gap-2.5 text-sm text-[#A1A8B3]">
          <a href="/#products" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-products-link">Tube styles</a>
          <a href="/#sizes" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-sizes-link">Standard diameters</a>
          <a href="/#finishes" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-finishes-link">Print finishes</a>
          <a href="/#quote" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-quote-link">Request a quote</a>
        </div>
      </div>
      <div>
        <p className="font-mono-spec text-[10px] uppercase tracking-[0.3em] text-[#666F7D] mb-4">Studio</p>
        <a href={`mailto:${email}`} className="text-sm text-[#D9A76A] hover:text-[#E6CA65] transition-colors" data-testid="footer-email-link">
          {email}
        </a>
        <div className="flex items-center gap-2 mt-6 text-[#666F7D]">
          <LogoMark size={16} />
          <span className="text-xs">MOQ 250 · Dispatch from 3 weeks</span>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 py-5">
      <p className="text-center text-[11px] font-mono-spec tracking-[0.2em] text-[#666F7D]">
        © {new Date().getFullYear()} TUBEBOXESDIRECT.COM BY BRU PRINT AND PACKAGING LIMITED — ALL RIGHTS RESERVED
      </p>
    </div>
  </footer>
);
